import { useEffect, useState, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { Box, Button, Input, Typography, Sheet } from '@mui/joy';
import { AuthContext } from '../context/AuthContext';

export default function NewPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [sessionReady, setSessionReady] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const token = searchParams.get('token');
    const type = searchParams.get('type');

    console.log('Recovery token:', token);

    if (token && type === 'recovery') {
      const timeout = setTimeout(() => {
        if (!sessionReady) setError('Session verification timed out.');
      }, 5000);

      supabase.auth.exchangeCodeForSession(token)
        .then(() => {
          clearTimeout(timeout);
          setSessionReady(true);
        })
        .catch(err => {
          console.error('Error exchanging token:', err);
          setError('Token is invalid or expired.');
        });
    } else if (!token && user) {
      console.log('No token in URL, but user is already logged in. Proceeding.');
      setSessionReady(true);
    }
  }, [searchParams, user]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const { error } = await supabase.auth.updateUser({ password });
    if (error) {
      setError(error.message);
    } else {
      setSubmitted(true);

      // Fetch the updated session to get user metadata
      const { data: { user: currentUser } } = await supabase.auth.getUser();

      const isClient = currentUser?.user_metadata?.user_type === 'client';
      const redirectUrl = isClient
        ? 'https://clients.fldandp.com'
        : 'https://thegrid.fldandp.com';

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        minHeight: '100vh',
        bgcolor: 'background.body',
        px: 2,
        textAlign: 'center',
      }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 400,
          width: '100%',
          p: 4,
          borderRadius: 'md',
          boxShadow: 'md',
          mx: 'auto',
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <img
            src="/the_grid_logo.png"
            alt="The Grid Logo"
            style={{ maxWidth: '160px', marginBottom: '1rem', display: 'block', marginInline: 'auto' }}
          />
          <Typography level="h4">Set Your Password</Typography>
        </Box>

        {sessionReady ? (
          submitted ? (
            <Typography>Success! Redirecting to login...</Typography>
          ) : (
            <>
              <Input
                type="password"
                placeholder="New password"
                fullWidth
                sx={{ mb: 2 }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {error && (
                <Typography color="danger" level="body-sm" sx={{ mb: 1 }}>
                  {error}
                </Typography>
              )}
              <Button fullWidth onClick={handleSubmit}>
                Set Password
              </Button>
            </>
          )
        ) : (
          <Typography>Verifying recovery link...</Typography>
        )}
      </Sheet>
    </Box>
  );
}